/* BODIED first-order subscriber gift — self-contained (UI + logic). Works with Kaching Cart drawer or Dawn drawer. */
(() => {
  const C = window.BODIED_GIFT || {};
  const G = {
    claimed: !!C.claimed,
    prop: '_first_order_gift',
    pdpHandle: 'crush-control-drops',
    defaultFlavor: 'Chocolate',
    // Real 30-count bottles (no separate gift SKU -> stock tracked once)
    // Only a subscription to one of these products earns the gift (product handles).
    eligibleProductIds: [8895020761343, 10349944602879], // BODIED SUPERFOOD COFFEE: live product page, then the -test product page
    eligibleHandles: ['coffee'], // product handle of BODIED SUPERFOOD COFFEE (the test page bodied-superfood-coffee-test is the same product)
    variants: { Chocolate: 46168486379775, Hazelnut: 46168486347007 },
    price: '$39.99',
  };
  const giftIds = Object.values(G.variants).map(String);
  const isGift = (l) => giftIds.includes(String(l.variant_id)) && l.properties && l.properties[G.prop] === 'true';
  const isSub = (l) => !!l.selling_plan_allocation;
  const isCoffee = (l) => G.eligibleProductIds.includes(Number(l.product_id)) || G.eligibleHandles.includes(l.handle);
  const qualifies = (l) => isSub(l) && !isGift(l) && isCoffee(l);
  // Pristine fetch from a hidden same-origin iframe: Kaching Bundles patches window.fetch on the PDP and injects its
  // bundle item into ANY /cart/add call (that created duplicate 60/90 subscription lines). Our own calls bypass it.
  let pf;
  const pristine = () => {
    if (!pf) {
      const i = document.createElement('iframe');
      i.style.cssText = 'display:none';
      i.setAttribute('aria-hidden', 'true');
      (document.body || document.documentElement).appendChild(i);
      pf = i.contentWindow.fetch.bind(i.contentWindow);
    }
    return pf;
  };
  const j = (url, body) =>
    pristine()(location.origin + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-FOG': '1' }, body: JSON.stringify(body) }).then((r) => r.json());
  // /discount/CODE replaces whatever code the cart already had, so re-apply FIRSTGIFT together with any code already applied (e.g. WELCOME15).
  const applyGiftCode = () => {
    let cur = [];
    try {
      const m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (m) cur = decodeURIComponent(m[1]).split(',').map((x) => x.trim()).filter(Boolean);
    } catch (e) {}
    const codes = [...cur.filter((c) => c.toUpperCase() !== 'FIRSTGIFT'), 'FIRSTGIFT'];
    // Apply through the cart API (same call Kaching's own code field makes) so the code is stored ON the cart and the
    // Kaching drawer lists it under "Discounts". The old /discount/ link only set a cookie, which the drawer never shows.
    return fetch('/cart/update.js?kaching-cart=true', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-FOG': '1' }, body: JSON.stringify({ discount: codes.join(',') }) }).catch(() => {});
  };
  const addGift = (flavor) =>
    j('/cart/add.js', { items: [{ id: G.variants[flavor], quantity: 1, properties: { [G.prop]: 'true' } }] }).then((r) => { giftInCart = true; applyGiftCode().then(() => fetch('/cart.js')); return r; });
 
  let giftInCart; // undefined until the first cart read
  let fast = false; // true while an early (parallel) gift add is in flight
  const _fetch = window.fetch.bind(window);
  const planned = (b) => {
    try {
      if (!b) return false;
      if (typeof b === 'string') return /selling_plan(?:"|\]|%5D)?\s*[:=]\s*"?\d+/.test(b);
      if (b instanceof FormData || b instanceof URLSearchParams) {
        for (const [k, v] of b.entries()) if (/selling_plan$/.test(k) && v) return true;
      }
    } catch (e) {}
    return false;
  };
  // Speed-up: add the gift the moment a subscription add succeeds, and hold that response back until the gift is in the
  // cart, so the drawer opens ONCE with the gift already there (no visible swap). Sequential, never parallel: two
  // concurrent adds can create two carts.
  window.fetch = function (u, o) {
    let path = '';
    try { path = new URL(typeof u === 'string' ? u : u.url, location.href).pathname; } catch (e) {}
    const ours = o && o.headers && o.headers['X-FOG'];
    // Customer enters another code (e.g. WELCOME15) while the gift is in the cart: the theme/cart app replaces the cart's
    // code list, which drops FIRSTGIFT and makes the new code look invalid. Always send FIRSTGIFT along with it.
    if (!ours && !G.claimed && giftInCart) {
      try {
        const withGift = (v) => {
          const a = String(v).split(',').map((x) => x.trim()).filter(Boolean);
          if (!a.length) return v;
          // customer's code first, FIRSTGIFT last (the order that worked when WELCOME15 was applied before the gift)
          const others = a.filter((x) => x.toUpperCase() !== 'FIRSTGIFT');
          return others.length ? [...others, 'FIRSTGIFT'].join(',') : 'FIRSTGIFT';
        };
        const url = new URL(typeof u === 'string' ? u : u.url, location.href);
        const log = (window.__fogLog = window.__fogLog || []);
        if (/discount/i.test(url.pathname + url.search) || (o && typeof o.body === 'string' && /discount/i.test(o.body))) log.push({ path: url.pathname + url.search, body: o && o.body });
        if (typeof u === 'string' && url.pathname.indexOf('/discount/') === 0 && url.pathname.length > 10) {
          u = location.origin + '/discount/' + withGift(decodeURIComponent(url.pathname.slice(10))).split(',').map(encodeURIComponent).join(',') + url.search;
        } else if (typeof u === 'string' && url.searchParams.get('discount')) {
          url.searchParams.set('discount', withGift(url.searchParams.get('discount')));
          u = url.toString();
        }
        if (o && typeof o.body === 'string' && /"discount"/.test(o.body)) {
          const b = JSON.parse(o.body);
          if (b && b.discount) { b.discount = withGift(Array.isArray(b.discount) ? b.discount.join(',') : b.discount); o = Object.assign({}, o, { body: JSON.stringify(b) }); }
        } else if (o && o.body instanceof FormData && o.body.get('discount')) {
          o.body.set('discount', withGift(o.body.get('discount')));
        } else if (o && o.body instanceof URLSearchParams && o.body.get('discount')) {
          o.body.set('discount', withGift(o.body.get('discount')));
        }
      } catch (e) {}
    }
    if (/\/cart\/add(\.js)?$/.test(path) && !ours && !fast && !G.claimed && giftInCart === false && planned(o && o.body)) {
      fast = true;
      return _fetch(u, o)
        .then((r) => {
          if (!r.ok) return r;
          return r.clone().json().then((d) => {
            const its = d && d.items ? d.items : d ? [d] : [];
            return its.some((l) => isCoffee(l) && l.selling_plan_allocation) ? addGift(G.defaultFlavor).then(() => r, () => r) : r;
          }, () => r);
        })
        .finally(() => { fast = false; kick(); });
    }
    // Any cart change made by the theme (e.g. removing the subscription line) must re-run sync so the gift is cleared.
    if (/\/cart\/(change|update|clear)(\.js)?$/.test(path) && !ours) {
      return _fetch(u, o).then((r) => {
        r.clone().json().then((c) => {
          if (c && c.items && c.items.some(isGift) && !c.items.some(qualifies)) sync(); // gift-only cart: clear NOW
        }).catch(() => {});
        kick();
        return r;
      });
    }
    return _fetch(u, o);
  };
 
  const css = document.createElement('style');
  css.textContent =
    '.fog-box{border:1px dashed currentColor;border-radius:8px;padding:12px 14px;margin:12px 16px;font-size:14px;line-height:1.4}' +
    '.fog-title{font-weight:700;margin:0 0 8px}' +
    '.fog-price{margin:8px 0 0}#fog-cart .fog-select{margin-top:10px!important}.fog-gift-row .fog-box{margin:6px 0;padding:8px 10px}.fog-gift-row .kaching-cart-item__selling-plan-upgrade,.fog-gift-row .kaching-cart-item__option-names,.fog-gift-row .kaching-cart-item__variant-selectors,.fog-gift-row .kaching-cart-item__quantity-controls,.fog-gift-row .kaching-cart-item__remove,.fog-gift-row .product-option,.fog-gift-row .cart-item__quantity,.fog-gift-row cart-remove-button,.fog-gift-row quantity-input,.fog-gift-row .cart-item__details>dl,.fog-gift-row .kaching-cart-item__selling-plan{display:none!important}.fog-gift-row .fog-price{display:none}';
  document.head.appendChild(css);
 
  /* ---------- PDP: always show the offer, never adds anything ---------- */
  function mountPdp() {
    if (!location.pathname.endsWith('/products/' + G.pdpHandle)) return;
    if (document.getElementById('fog-pdp')) return;
    const anchor = document.querySelector('.product-form__buttons') || document.querySelector('product-form');
    if (!anchor) return;
    const d = document.createElement('div');
    d.id = 'fog-pdp';
    d.className = 'fog-box';
    d.innerHTML =
      '<strong>Subscribe &amp; get a FREE bottle of Crush &amp; Control Drops</strong> with your first order ' +
      '(Chocolate or Hazelnut) &mdash; choose your flavor in the cart. <small>First subscription order only.</small>';
    anchor.parentNode.insertBefore(d, anchor.nextSibling);
  }
 
 
  /* ---------- "Buy it now" on the product page ----------
     The theme's Buy it now button replaces the cart and goes straight to checkout, so a gift added to the cart beforehand is
     wiped out. Instead, run the normal Add to cart (which already adds the gift), wait until the cart holds the coffee
     subscription AND the gift, then go to checkout ourselves. */
  document.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest && e.target.closest('.buy-now-button');
    if (!btn || G.claimed) return;
    const form = btn.closest('form');
    const plan = form && form.querySelector('[name="selling_plan"]');
    if (!plan || !plan.value) return; // one-time purchase: no gift, keep the theme's own behavior
    const pid = form.querySelector('[name="product-id"]');
    if (!(pid && G.eligibleProductIds.includes(Number(pid.value)))) return;
    const atc = [...form.querySelectorAll('button[type="submit"],button[name="add"],input[type="submit"]')].find((x) => x !== btn && !x.classList.contains('buy-now-button'));
    if (!atc) return; // can't find Add to cart: fall back to the theme's own Buy it now
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.dataset.fogBusy) return;
    btn.dataset.fogBusy = '1';
    btn.style.opacity = '.6';
    btn.style.pointerEvents = 'none';
    (async () => {
      const qty = (c) => c.items.filter(qualifies).reduce((n, l) => n + l.quantity, 0);
      let base = 0;
      try { base = qty(await (await fetch('/cart.js')).json()); } catch (err) {}
      atc.click();
      const t0 = Date.now();
      const poll = async () => {
        let ready = false;
        try {
          const c = await (await fetch('/cart.js')).json();
          ready = qty(c) > base && c.items.some(isGift);
        } catch (err) {}
        if (ready || Date.now() - t0 > 9000) { window.location.href = '/checkout'; return; }
        setTimeout(poll, 250);
      };
      setTimeout(poll, 400);
    })();
  }, true);
 
  /* ---------- Cart: auto-add, flavor picker, FREE ---------- */
  let busy = false;
 
  async function refreshDrawer() {
    if (document.getElementById('kaching-cart')) return; // Kaching Cart drawer re-renders itself on /cart/*.js calls
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const html = await (await fetch('/?section_id=cart-drawer')).text();
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
    if (fresh) drawer.innerHTML = fresh.innerHTML;
    drawer.classList.toggle('is-empty', !!fresh && fresh.classList.contains('is-empty'));
  }
 
  let again = false;
  async function sync() {
    if (busy || fast) { again = true; return; }
    busy = true;
    try {
      const cart = await (await fetch('/cart.js')).json();
      const gifts = cart.items.filter(isGift);
      giftInCart = gifts.length > 0;
      const eligible = !G.claimed && cart.items.some(qualifies);
      // Clear through the page's own fetch (flagged so our hook ignores it) so Kaching sees the change and redraws the drawer.
      // Then verify with a fresh cart read and retry by line number if a gift line survived.
      const clear = async () => {
        const post = (body) => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-FOG': '1' }, body: JSON.stringify(body) });
        await post({ updates: Object.fromEntries(gifts.map((g) => [g.key, 0])) });
        let c = await (await fetch('/cart.js')).json();
        if (c.items.some(isGift)) {
          // updates as an array = new quantity for every line, in cart order
          await post({ updates: c.items.map((l) => (isGift(l) ? 0 : l.quantity)) });
          await fetch('/cart.js');
        }
        giftInCart = false;
      };
 
      if (!eligible && gifts.length) { await clear(); await refreshDrawer(); return; }
      if (eligible && !gifts.length) { await addGift(G.defaultFlavor); await refreshDrawer(); return; }
      if (eligible && (gifts.length > 1 || gifts[0].quantity !== 1 || isSub(gifts[0]))) {
        await clear(); await addGift(G.defaultFlavor); await refreshDrawer(); return;
      }
      render(eligible ? gifts[0] : null, eligible ? cart.items.indexOf(gifts[0]) : -1);
    } finally {
      busy = false;
      if (again) { again = false; kick(); }
    }
  }
 
  async function swap(flavor, current) {
    if (busy) return;
    busy = true;
    try {
      await j('/cart/change.js', { id: current.key, quantity: 0 });
      await addGift(flavor); // order line = real SKU for the chosen flavor
      await refreshDrawer();
    } finally {
      busy = false;
    }
  }
 
  // Find the gift's row in Kaching's drawer. Kaching's row order doesn't always match /cart.js order, so match by line key,
  // then by product title (ignoring the paid-subscription row), and only then fall back to the cart index.
  function findRow(gift, idx) {
    const rows = [...document.querySelectorAll('#kaching-cart .kaching-cart-item-container')];
    if (!rows.length) return null;
    let m = rows.filter((r) => r.outerHTML.includes(gift.key));
    if (m.length === 1) return m[0];
    const t = String(gift.product_title || '').trim().toLowerCase();
    if (t) {
      m = rows.filter((r) => {
        const el = r.querySelector('.kaching-cart-item__title');
        return el && el.textContent.trim().toLowerCase() === t;
      });
      if (m.length > 1) {
        const oneTime = m.filter((r) => !/delivered every|every \d+ day/i.test(r.textContent));
        if (oneTime.length) m = oneTime;
      }
      if (m.length === 1) return m[0];
      if (m.length > 1) return m[0];
    }
    return rows[idx] || null;
  }
 
  function render(gift, idx) {
    const row = gift ? findRow(gift, idx) : null;
    const ex = document.getElementById('fog-cart');
    if (gift && ex && ex.dataset.key === gift.key && (!row || ex.closest('.kaching-cart-item-container') === row)) return; // unchanged: keep an open dropdown open
    document.querySelectorAll('#fog-cart').forEach((n) => n.remove());
    document.querySelectorAll('.fog-gift-row').forEach((n) => n.classList.remove('fog-gift-row'));
    if (!gift) return;
    const box = document.createElement('div');
    box.id = 'fog-cart';
    box.dataset.key = gift.key;
    box.className = 'fog-box';
    box.innerHTML =
      '<p class="fog-title">Choose Your FREE Crush &amp; Control Drops</p>' +
      '<select class="kaching-cart-selector fog-select" aria-label="Flavor">' +
      Object.keys(G.variants).map((f) => `<option value="${f}">${f}</option>`).join('') +
      '</select><p class="fog-price"><strong>FREE</strong></p>';
 
    // Mount directly under the product title inside the gift row
    const k = row;
    const d = document.getElementById('CartDrawer-Item-' + (idx + 1)) || document.getElementById('CartItem-' + (idx + 1));
    if (k) {
      k.classList.add('fog-gift-row');
      const info = k.querySelector('.kaching-cart-item__info');
      const title = info && info.querySelector('.kaching-cart-item__title');
      if (!info) return;
      title ? title.after(box) : info.prepend(box);
    } else if (d) {
      d.classList.add('fog-gift-row');
      const name = d.querySelector('.cart-item__name');
      name ? name.after(box) : d.appendChild(box);
    } else {
      const f = document.querySelector('.cart__footer');
      if (!f) return;
      f.parentNode.insertBefore(box, f);
    }
    const sel = box.querySelector('select');
    sel.value = Object.keys(G.variants).find((f) => String(G.variants[f]) === String(gift.variant_id)) || G.defaultFlavor;
    sel.addEventListener('change', () => swap(sel.value, gift));
  }
 
  // Re-sync whenever Dawn re-renders the drawer or the cart changes
  let t;
  const kick = () => { clearTimeout(t); t = setTimeout(sync, 60); };
  new MutationObserver((m) => {
    if (m.some((x) => [...x.addedNodes].some((n) => n.nodeType === 1 && n.id !== 'fog-cart' && !n.closest?.('#fog-cart')))) kick();
  }).observe(document.body, { childList: true, subtree: true });
  // Safety net: while the cart drawer is open, re-check regularly so the gift is cleared even if a removal isn't seen above.
  setInterval(() => { if (document.querySelector('#kaching-cart .active, #kaching-cart.active, cart-drawer.active, cart-drawer.is-open')) kick(); }, 600);
  document.addEventListener('DOMContentLoaded', () => { mountPdp(); kick(); });
  if (document.readyState !== 'loading') { mountPdp(); kick(); }
})();
 